import { useTheme } from '@fluentui/react';
import { FC, useMemo } from 'react';
import StyledDonutChart from './StyledDonutChart';

interface IProps {
    percent: number;
    color: string;
}

const SlaDisplay: FC<IProps> = ({ percent, color }) => {
    const { palette } = useTheme();

    const data = useMemo(
        () => ({
            chartData: [
                ...(percent > 0 ? [{ legend: '', data: percent, color }] : []),
                ...(percent < 100 ? [{ legend: '', data: 100 - percent, color: palette.neutralQuaternary }] : []),
            ],
        }),
        [color, palette.neutralQuaternary, percent],
    );

    return (
        <StyledDonutChart
            text={`${percent}%`}
            data={data}
            innerRadius={33}
            hideTooltip={true}
            hideLegend={true}
            height={95}
            width={95}
        />
    );
};

export default SlaDisplay;